import { atom, selector } from "recoil"

export const localMuteAtom = atom<boolean>({
  key: "localMuteAtom",
  default: undefined
})

export const wpLocalMuteControlPropsAtom = atom({
  key: "wpLocalMuteControlPropsAtom",
  default: {
    enabled: false,
    value: false
  }
})

interface LocallMuteCallbackSelectorProps {
  handleReturnData: () => Promise<boolean>
}

export const locallMuteCallbackSelector =
  selector<LocallMuteCallbackSelectorProps>({
    key: "locallMuteCallbackAtomSelector",
    get: ({ getCallback }) => {
      const handleReturnData = getCallback(({ snapshot }) => async () => {
        const data = await snapshot.getPromise(localMuteAtom)

        return data
      })
      return { handleReturnData }
    }
  })
